<script>
import {
  ButtonElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/button-element/button-element-mixin";
import ClickAction from "%/dynamic-components/render-engine/options/click-actions/click-action";
import BaseButtonElement
  from "%/dynamic-components/render-engine/components/production/elements/button-element/BaseButtonElement.vue";

export default {
  name: "ButtonElement",
  elementPanelSettings: {
    displayName: "Button",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  extends: BaseButtonElement,
  mixins: [ButtonElementMixin],
  options: [
    ClickAction,
  ],
};
</script>

<style lang="scss" scoped>
</style>
